import { render, staticRenderFns } from "./BalanceKpisTab.vue?vue&type=template&id=51b3a988&scoped=true"
import script from "./BalanceKpisTab.vue?vue&type=script&lang=js"
export * from "./BalanceKpisTab.vue?vue&type=script&lang=js"
import style0 from "./BalanceKpisTab.vue?vue&type=style&index=0&id=51b3a988&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b3a988",
  null
  
)

export default component.exports